import actionTypes from '../actions/action-types';

const initialState = {
  selectedMessagesList: [],
  hasAllMessagesSelected: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_MESSAGE_TO_SELECTED: {
      return {
        ...state,
        selectedMessagesList: [...state.selectedMessagesList, ...[action.selectedId]],
      };
    }
    case actionTypes.DELETE_MESSAGE_FROM_SELECTED: {
      return {
        ...state,
        selectedMessagesList: state.selectedMessagesList.filter((id) => id !== action.selectedId),
        hasAllMessagesSelected: false,
      };
    }
    case actionTypes.TOGGLE_SELECT_ALL_MESSAGES_POINTER: {
      let selectedMessagesList = [];
      if (!state.hasAllMessagesSelected) {
        selectedMessagesList = [...action.messagesList];
      }

      return {
        ...state,
        selectedMessagesList,
        hasAllMessagesSelected: !state.hasAllMessagesSelected,
      };
    }
    case actionTypes.SET_SELECT_ALL_MESSAGES_POINTER: {
      return {
        ...state,
        hasAllMessagesSelected: action.hasAllMessagesSelected,
      };
    }
    case actionTypes.CLEAR_SELECTED_MESSAGES_LIST:
    case actionTypes.RESET_INBOX: {
      return {
        ...state,
        selectedMessagesList: [],
        hasAllMessagesSelected: false,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/message/reducers/selected-messages.js